import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import { TVProvider } from './contexts/tv-channels.context';
import { WordPlayProvider } from './contexts/word-play.context';
import { GallaryProvider } from './contexts/image-gallary.context';

export const MAIN_FONT ='2Peas4thOfJuly';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <TVProvider>
      <WordPlayProvider>
        <GallaryProvider>
    <App />
    </GallaryProvider>
      </WordPlayProvider>
    </TVProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
